@if (storeLoaded) {
  <se-po-household-review
    [child]="child"
    [parent]="parent"
    [guardianInvites]="guardianInvites"
    (cancelInvite)="onCancelInvite($event)"
    (continue)="onContinue()"
    (addAnother)="onAddAnother()">
  </se-po-household-review>
}
